export const DURATION_OPTIONS = [
  "1 Month", "2 Months", "3 Months", "4 Months", "5 Months", "6 Months",
  "9 Months", "1 Year", "1.5 Years", "2 Years", "3 Years",
];

/** Defaults for each selected RFQ line (buyer picks quantity XOR area per line). */
export const newLineSpec = () => ({
  specType: "quantity",
  quantity: 1,
  areaValue: "",
  areaUnit: "sqft",
  size: "",
});
